import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CameraIcon, CheckIcon, ClockIcon, MapPinIcon, SparklesIcon, Trash2Icon } from 'lucide-react';
import { citizenAddress, liveCollection, materials } from '../../data/collectes';
import { binRequest, binRequestReference } from '../../data/binRequest';
import type { CollecteKind } from '../../hooks/useCollecteConversation';
interface CollecteMessageProps {
  kind: CollecteKind;
  live: boolean;
  photoAttached: boolean;
  onAddPhoto: () => void;
}
const eyebrow = 'flex items-center gap-2 text-sm font-bold text-ville-indigo';
const chipButton = 'inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo';
export function CollecteMessage({
  kind,
  live,
  photoAttached,
  onAddPhoto
}: CollecteMessageProps) {
  if (kind === 'requete-ouverte') {
    return <div data-id="element-672" data-mp="29vbpuddmrhqo">
        <p className={eyebrow} data-id="element-673" data-mp="29vk86ksivf99">
          <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-674" data-mp="29uisg30ka4l7" />
          Requête ouverte auprès de la Ville
        </p>
        <p className="mt-2 text-[17px] font-bold text-ville-navy" data-id="element-675" data-mp="24ueb6artx5tx">
          J’ai ouvert une requête aux Travaux publics pour votre bac non ramassé.
        </p>

        <div className="mt-4 rounded-2xl border border-slate-200 bg-ville-sand p-4" data-id="element-676" data-mp="2xk3ewvvxbjz8">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-677" data-mp="2sncyu8k4codt">
            Requête {binRequestReference}
          </p>
          <p className="mt-1 text-[15px] font-extrabold text-ville-navy" data-id="element-678" data-mp="2npbgxqyfiv3x">
            Bac non ramassé — {materials[liveCollection.material].label}
          </p>
          <dl className="mt-2 space-y-1 text-[13px] text-slate-600" data-id="element-679" data-mp="1c94m15p5htfd">
            <div className="flex items-center gap-1.5" data-id="element-680" data-mp="186q2skhkkrnk">
              <MapPinIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-681" data-mp="1856mitvwygls" />
              <dt className="sr-only" data-id="element-682" data-mp="19o6r60hvwtev">Adresse</dt>
              <dd data-id="element-683" data-mp="1en9u9feb0pk7">{citizenAddress}</dd>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-684" data-mp="1elyoxb57n9qz">
              <Trash2Icon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-685" data-mp="zq8yn0szsagg" />
              <dt className="sr-only" data-id="element-686" data-mp="14nrcn5lv9fvb">Collecte</dt>
              <dd data-id="element-687" data-mp="14qnayv1mm6ka">
                Collecte du jour · {liveCollection.sector} · {liveCollection.truck}
              </dd>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-688" data-mp="voe187e6mh7y">
              <ClockIcon className="h-3.5 w-3.5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-689" data-mp="vpyvdvwl3y5a" />
              <dt className="sr-only" data-id="element-690" data-mp="h0sy4dhb4i01">Délai</dt>
              <dd data-id="element-691" data-mp="lxjez30xrhmi">Rattrapage prévu dans les 48 heures ouvrables</dd>
            </div>
          </dl>
          <p className="mt-3 text-[13px] text-slate-600" data-id="element-692" data-mp="7xrucjfwz2zj">
            Laissez votre bac au bord de la rue. Vous serez avisée dès qu’une équipe est assignée.
          </p>
          {photoAttached && <p className="mt-2 text-[13px] font-semibold text-ville-deep" data-id="element-693" data-mp="3pggylrj6jkpa">Photo jointe à la requête</p>}
        </div>

        {live && <div className="mt-5 flex flex-wrap items-center gap-3" data-id="element-694" data-mp="3kjqjp7j42v5g">
            <Link to={`/mes-demandes/${binRequest.id}`} className="inline-flex items-center gap-2 rounded-full bg-ville-navy px-6 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-695" data-mp="2dc7pe4ekv9p">
              Suivre ma requête
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-696" data-mp="l1h6e767dq1n" />
            </Link>
            {!photoAttached && <button type="button" onClick={onAddPhoto} className={chipButton} data-id="element-697" data-mp="h39wnwa5pozy">
                <CameraIcon className="h-4 w-4" aria-hidden="true" data-id="element-698" data-mp="v1g9hojuso74" />
                Ajouter une photo
              </button>}
          </div>}
      </div>;
  }
  if (kind === 'suivi') {
    return <div data-id="element-699" data-mp="1a25coilop4t6">
        <p className={eyebrow} data-id="element-700" data-mp="1e5jrx71sth5k">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-701" data-mp="1e4s0m8f8i5l3" />
          Requête {binRequestReference}
        </p>
        <p className="mt-2 text-[15px] leading-relaxed text-ville-navy" data-id="element-702" data-mp="1ixl12k3o6rrd">
          C’est ajouté à votre requête. Les Travaux publics verront la précision avec le dossier.
        </p>
        {live && <Link to={`/mes-demandes/${binRequest.id}`} className={`mt-4 ${chipButton}`} data-id="element-703" data-mp="r6oozlpfor55">
            Voir le suivi
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-704" data-mp="v6z5hsauqzy9" />
          </Link>}
      </div>;
  }
  return <div data-id="element-705" data-mp="154vdwccengso">
      <p className={eyebrow} data-id="element-706" data-mp="154lpgt70dhp3">
        <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-707" data-mp="155wo6elljz9c" />
        Collectes
      </p>
      <p className="mt-2 text-[15px] leading-relaxed text-ville-navy" data-id="element-708" data-mp="2blqqhk5o54xj">
        Votre prochaine collecte est celle du jour ({materials[liveCollection.material].label},{' '}
        {liveCollection.sector}). Dites-moi si un bac n’a pas été ramassé et j’ouvre une requête.
      </p>
    </div>;
}